<template>
  <div class="item" @click="onClick">
    <i class="iconfont iconphysical"></i>
    <p class="title">
      {{title}}
      <span class="btn">查看解析>></span>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'examItem',
    props: {
      id: Number,
      title: String,
    },
    methods: {
      onClick() {
        this.$emit('tap', {
          id: this.id,
          title: this.title,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";
.item {
  display: flex;
  margin-top: 10px;
  padding: 10px 15px;
  background-color: #fff;
}

.iconfont {
  position: relative;
  top: 4px;
  color: $theme-color;
}

.title {
  flex: 1;
  margin-left: 10px;
  font-size: 16px;
  color: #333;
  line-height: 24px;
}

.btn {
  float: right;
  font-size: 12px;
  color: $theme-color;
}
</style>
